// extracted by mini-css-extract-plugin
export default {"header":"Pane-module__header__W66CO","stickyHeader":"Pane-module__stickyHeader__KI-nO"};